export const NODE_ISOLATION = false;
export const ENABLE_GITHUB_APP = false;
